import { render, staticRenderFns } from "./DownloadHandIn.vue?vue&type=template&id=7cb2ec4b&"
import script from "./DownloadHandIn.vue?vue&type=script&lang=js&"
export * from "./DownloadHandIn.vue?vue&type=script&lang=js&"
import style0 from "./DownloadHandIn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports